export const SEARCH_INDEX_NAME = process.env.NEXT_PUBLIC_ALGOLIA_INDEX

export type SearchHit = {
  objectID: string
  sku?: string
  slug: string
  title: string
  type: 'Product' | 'Page' | 'Article'
}
